import React from 'react';
import axios from 'axios';
import { Button, Card, Descriptions, Divider } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { SystemApi } from '../../../services/Api';

interface PanelUserProps {
    trans: (key: string) => string;
}

interface PanelUserState {
    accountTotal: number;
    accountActive: number;
    accountIncrCntToday: number;
    accountIncrCntYesterday: number;
    accountIncrCntThisWeek: number;
    accountIncrCntLastWeek: number;
    accountIncrCntThisMonth: number;
    accountIncrCntLastMonth: number;
    userTotal: number;
    userIncrCntToday: number;
    userIncrCntYesterday: number;
    userIncrCntThisWeek: number;
    userIncrCntLastWeek: number;
    userIncrCntThisMonth: number;
    userIncrCntLastMonth: number;
    loading: boolean;
}

const initialState: PanelUserState = {
    accountTotal: 0,
    accountActive: 0,
    accountIncrCntToday: 0,
    accountIncrCntYesterday: 0,
    accountIncrCntThisWeek: 0,
    accountIncrCntLastWeek: 0,
    accountIncrCntThisMonth: 0,
    accountIncrCntLastMonth: 0,
    userTotal: 0,
    userIncrCntToday: 0,
    userIncrCntYesterday: 0,
    userIncrCntThisWeek: 0,
    userIncrCntLastWeek: 0,
    userIncrCntThisMonth: 0,
    userIncrCntLastMonth: 0,
    loading: false,
};

export default class PanelUser extends React.Component<PanelUserProps, PanelUserState> {
    state: PanelUserState = initialState;

    updateInfo = (accountInfo: any = {}, userInfo: any = {}) => {
        this.setState({
            accountTotal: Number(accountInfo.total || 0),
            accountActive: Number(accountInfo.active || 0),
            accountIncrCntToday: Number(accountInfo.incrCntToday || 0),
            accountIncrCntYesterday: Number(accountInfo.incrCntYesterday || 0),
            accountIncrCntThisWeek: Number(accountInfo.incrCntThisWeek || 0),
            accountIncrCntLastWeek: Number(accountInfo.incrCntLastWeek || 0),
            accountIncrCntThisMonth: Number(accountInfo.incrCntThisMonth || 0),
            accountIncrCntLastMonth: Number(accountInfo.incrCntLastMonth || 0),
            userTotal: Number(userInfo.total || 0),
            userIncrCntToday: Number(userInfo.incrCntToday || 0),
            userIncrCntYesterday: Number(userInfo.incrCntYesterday || 0),
            userIncrCntThisWeek: Number(userInfo.incrCntThisWeek || 0),
            userIncrCntLastWeek: Number(userInfo.incrCntLastWeek || 0),
            userIncrCntThisMonth: Number(userInfo.incrCntThisMonth || 0),
            userIncrCntLastMonth: Number(userInfo.incrCntLastMonth || 0),
        });
    };

    refreshInfo = async () => {
        const lang = localStorage.getItem('lang') || 'zh_CN';
        this.setState({ loading: true });

        try {
            const response = await axios.post(SystemApi.GET_USER_STATUS, {
                lang: lang.split('_')[0],
            });

            if (response.data?.data) {
                const data = response.data.data;
                this.setState({
                    accountTotal: Number(data.total || 0),
                    accountActive: Number(data.active || 0),
                });
            }
        } catch (error) {
            console.error('PanelUser.refreshInfo()', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    renderRows = (rows: Array<[string, unknown]>) =>
        rows.map(([label, value]) => (
            <Descriptions.Item key={label} label={this.props.trans(label)}>
                {String(value ?? 0)}
            </Descriptions.Item>
        ));

    render() {
        const { trans: t } = this.props;
        const { loading } = this.state;

        const accountRows: Array<[string, unknown]> = [
            ['totalAccountCnt', this.state.accountTotal],
            ['activeAccountCnt', this.state.accountActive],
            ['accountIncrCntToday', this.state.accountIncrCntToday],
            ['accountIncrCntYesterday', this.state.accountIncrCntYesterday],
            ['accountIncrCntThisWeek', this.state.accountIncrCntThisWeek],
            ['accountIncrCntLastWeek', this.state.accountIncrCntLastWeek],
            ['accountIncrCntThisMonth', this.state.accountIncrCntThisMonth],
            ['accountIncrCntLastMonth', this.state.accountIncrCntLastMonth],
        ];

        const userRows: Array<[string, unknown]> = [
            ['totalUserCnt', this.state.userTotal],
            ['userIncrCntToday', this.state.userIncrCntToday],
            ['userIncrCntYesterday', this.state.userIncrCntYesterday],
            ['userIncrCntThisWeek', this.state.userIncrCntThisWeek],
            ['userIncrCntLastWeek', this.state.userIncrCntLastWeek],
            ['userIncrCntThisMonth', this.state.userIncrCntThisMonth],
            ['userIncrCntLastMonth', this.state.userIncrCntLastMonth],
        ];

        return (
            <Card
                title={t('userMgmt')}
                extra={
                    <Button
                        type="text"
                        icon={<ReloadOutlined />}
                        loading={loading}
                        onClick={this.refreshInfo}
                    >
                        {t('refresh')}
                    </Button>
                }
            >
                <Descriptions title={t('accountInfo')} bordered column={1} size="small">
                    {this.renderRows(accountRows)}
                </Descriptions>

                <Divider />

                <Descriptions title={t('userInfo')} bordered column={1} size="small">
                    {this.renderRows(userRows)}
                </Descriptions>
            </Card>
        );
    }
}
